/**
 * Ryan O'Dowd
 * 2022-07-07
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Linking,
  Platform,
  View,
} from 'react-native';
import Button from '@components/common/Button';
import ListItem from '@components/ListItem';
import React from 'react';
import Text from '@components/common/Text';
import getStyles from './styles';
import globals from '@utils/globals';
import hooks from '@hooks';
import utilities from '@utils/utilities';

const NewVersion = (props: NewVersionProps) => {
  const styles = hooks.useStyles(getStyles);
  const i18n = hooks.useI18n();

  if (!utilities.isNewAppVersionWithReleaseNotesAvailable()) {
    return null;
  }

  return (
    <ListItem variant='accent'>
      <Text style={styles.text}>{i18n('aNewerVersionIsAvailable')}</Text>
      {props.isFeedbackChat && <Text style={styles.text}>{i18n('ifReportingABugPleaseUpdate')}</Text>}
      <View style={styles.updateButtonWrapper}>
        <Button
          mode='contained'
          onPress={() => Linking.openURL(Platform.OS === 'android' ? globals.playStoreUrl : globals.appStoreUrl)}
        >
          {i18n('updateNow')}
        </Button>
      </View>
    </ListItem>
  );
};

class NewVersionProps {
  isFeedbackChat?: boolean;
};

export default NewVersion;
